import { useTranslation } from 'react-i18next'

import { Alert, ButtonWithSpinner, Divider, Loading, Text } from '@reveni-io/reveni-ui'

import {
  getConceptAmountError,
  getSumOfSelectedConcepts,
  hasConceptError,
  isBreakdownableConcept,
  isFeeConcept,
} from '@/returns/helpers/helpers'

import ConceptToggle from '../ConceptToggle/ConceptToggle'
import RefundMethodSelector from '../RefundMethodSelector/RefundMethodSelector'
import RefundNotes from '../RefundNotes/RefundNotes'
import TotalRefundAmount from '../TotalRefundAmount/TotalRefundAmount'
import RefundMethodExtraAmount from './RefundMethodExtraAmount/RefundMethodExtraAmount'
import useEditTransactionAmount from './useEditTransactionAmount/useEditTransactionAmount'
import * as Styles from './styles'

const EditTransactionAmount = ({
  show,
  onClose,
  lineItems,
  concepts,
  currency,
  refundMethods,
  refundMethod,
  onSave,
  returnId,
  loading,
  editable,
  directionActionButtons = 'row',
}) => {
  const { t } = useTranslation()

  const {
    note,
    setNote,
    transactionConcepts,
    refundMethodSelected,
    setRefundMethodSelected,
    getSelectedConcepts,
    onSelectConcept,
    onChangeConceptAmount,
    onChangeItemAmount,
    refundMethodExtraAmount,
    hasConceptAmountErrors,
    isFormValid,
  } = useEditTransactionAmount({
    concepts,
    refundMethod,
    returnId,
    show,
  })

  const handleSave = () => {
    onSave({ transactionConcepts, refundMethodSelected, note })
  }

  return (
    <Loading show={loading}>
      <Styles.Container>
        <Text type="bodyMRegular">{t('Elige los conceptos a incluir en el resultado de la transacción:')}</Text>
        {transactionConcepts?.map(concept => (
          <ConceptToggle
            key={concept.id}
            label={concept.label}
            selected={concept.selected}
            amount={concept.amount}
            maxAmount={concept.max_amount}
            currency={currency}
            isNegative={isFeeConcept(concept)}
            editable={editable}
            expandable={isBreakdownableConcept(concept)}
            items={editable ? concept.items : null}
            lineItems={lineItems}
            error={getConceptAmountError(concept)}
            hasError={hasConceptError(concept)}
            onToggle={() => onSelectConcept(concept)}
            onChangeAmount={amount => onChangeConceptAmount(concept.id, amount)}
            onChangeItemAmount={(itemId, amount) => onChangeItemAmount(concept.id, itemId, amount)}
          />
        ))}
        <Divider />
        <RefundMethodExtraAmount
          refundMethod={refundMethodSelected}
          amount={refundMethodExtraAmount}
          currency={currency}
        />
        <TotalRefundAmount
          currency={currency}
          selectedConcepts={getSelectedConcepts()}
          extraAmount={refundMethodExtraAmount}
          showExtra={refundMethodExtraAmount > 0}
          hasError={hasConceptAmountErrors}
        />
        {hasConceptAmountErrors && <Alert type="error">{t('Corrige los errores de importe para continuar')}</Alert>}
        {getSumOfSelectedConcepts(getSelectedConcepts()) > 0 && (
          <RefundMethodSelector
            refundMethods={refundMethods}
            refundMethodSelected={refundMethodSelected}
            onChange={setRefundMethodSelected}
          />
        )}
        <RefundNotes value={note} onChange={setNote} />
        <Styles.Actions direction={directionActionButtons}>
          <ButtonWithSpinner
            onClick={handleSave}
            fullWidth
            defaultLabel={t('Guardar cambios')}
            disabled={!isFormValid()}
          />
          <ButtonWithSpinner onClick={onClose} variant="outlined" fullWidth defaultLabel={t('Cancelar')} />
        </Styles.Actions>
      </Styles.Container>
    </Loading>
  )
}

export default EditTransactionAmount
